module.exports = __webpack_public_path__ + "static/media/15.bfbf26c4.svg";